module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Hazel_HK.2f3facfd.png";